import { teacherMessage } from './teacher-language.js';
import type { LibraryReleaseView, LibraryPinView } from '../shared/library.js';
import type { LibraryReleaseMetrics, LibraryMetricsFilter } from '../shared/library-feedback.js';
export type RatedLibraryRelease = LibraryReleaseView & {metrics?: LibraryReleaseMetrics};
export interface LibraryCatalogResult { releases: RatedLibraryRelease[]; nextOffset: number | null; }
export interface LibraryDetailResult { release: RatedLibraryRelease; history: RatedLibraryRelease[]; related: RatedLibraryRelease[]; pins: LibraryPinView[]; }
export interface LibraryQuery extends LibraryMetricsFilter { subject?: string; course?: string; grade?: number; kind?: 'assignment' | 'resource'; offset?: number; limit?: number; }
export function libraryQueryString(query: LibraryQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) if (value !== undefined && value !== '') params.set(key, String(value));
  return params.toString();
}
export const releaseLabel = (r: Pick<LibraryReleaseView, 'releaseNumber'>): string => `Version ${r.releaseNumber}`;
export const teacherCredit = (id: string | null, name?: string): string => name?.trim() || (id ? 'District teacher' : 'TIP');

/** Keep transport paths and machine codes out of teacher-facing recovery messages. */
export function libraryErrorMessage(error: unknown, fallback: string): string {
  return teacherMessage(error, fallback);
}
